import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login as apiLogin } from '../utils/api';
import { Shield, ArrowRight } from 'lucide-react';

export default function LoginPage() {
  const { login }  = useAuth();
  const navigate   = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await apiLogin(email, password);
      if (result.user?.role !== 'system_admin') {
        setError('Access denied — System Admin credentials required.');
        setLoading(false);
        return;
      }
      login(result.token, result.user, result.refresh_token);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-grid-bg" />
      <div className="login-glow" />

      <div className="login-card">
        <div className="login-brand">
          <div className="logo">
            <Shield size={20} />
          </div>
          <h1>Zeus<span>CMS</span></h1>
          <p>System Admin Console</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@zeuscms.com"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button
            className="btn btn-primary btn-lg"
            type="submit"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', marginTop: 4 }}
          >
            {loading ? 'Authenticating…' : <>Sign In <ArrowRight size={15} /></>}
          </button>
        </form>

        <p style={{
          marginTop: 20,
          textAlign: 'center',
          fontFamily: 'var(--font-mono)',
          fontSize: '0.62rem',
          color: 'var(--text-muted)',
          letterSpacing: '0.06em',
        }}>
          SYSTEM ADMIN ACCESS ONLY
        </p>
      </div>
    </div>
  );
}
